import { useState } from "react";
import { List } from "@phosphor-icons/react";
import Sidebar from "./Sidebar";

export default function Layout({ children, title, subtitle, actions }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-white">
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <main className="flex-1 min-w-0 w-full">
        <header className="border-b border-black/10 bg-white sticky top-0 z-30">
          <div className="flex items-center justify-between gap-3 px-4 md:px-8 py-4 md:py-5">
            <div className="flex items-center gap-3 min-w-0 flex-1">
              <button
                type="button"
                onClick={() => setMobileOpen(true)}
                className="md:hidden p-2 -ml-2 text-[#0A0A0A] hover:bg-black/5 flex-shrink-0"
                aria-label="Open menu"
                data-testid="mobile-menu-button"
              >
                <List size={22} weight="bold" />
              </button>
              <div className="min-w-0 flex-1">
                {title && <h1 className="font-display text-xl sm:text-2xl md:text-3xl font-black tracking-tighter text-[#0A0A0A] truncate">{title}</h1>}
                {subtitle && <p className="text-xs md:text-sm text-[#717680] mt-1 truncate">{subtitle}</p>}
              </div>
            </div>
            {actions && (
              <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>
            )}
          </div>
        </header>
        <div className="px-4 md:px-8 py-5 md:py-8">{children}</div>
      </main>
    </div>
  );
}
